import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MY_CARDS_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useAvailableRarities } from '@sorare/core/src/hooks/my-cards/useAvailableRarities';

export const CardsPage = () => {
  const availableRarities = useAvailableRarities();
  const defaultRarity = availableRarities[0];
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_CARDS_TYPE, {
        params: {
          type: defaultRarity,
        },
      })}
      replace
    />
  );
};

export default CardsPage;
